import {
  Card,
  Typography,
  Chip,
  Grid,
  Box,
  Button
} from "@mui/material";

export default function ProductCard({
  title,
  discount,
  description,
  prices = [],
  onEnquiry
}) {
  return (
    <Card
      sx={{
        p: 5,
        borderRadius: 4,
        background: "#ffffff",
        boxShadow: "0 8px 30px rgba(0,0,0,0.06)",
        transition: "all 0.35s ease",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        "&:hover": {
          transform: "translateY(-8px)",
          boxShadow: "0 16px 40px rgba(0,0,0,0.12)"
        }
      }}
    >
      <Box>
        {/* Discount Badge */}
        <Chip
          label={discount}
          sx={{
            backgroundColor: "#E67E22",
            color: "#fff",
            fontWeight: 600,
            borderRadius: 2
          }}
        />

        {/* Title */}
        <Typography
          variant="h5"
          fontWeight={700}
          mt={3}
          sx={{ color: "#1F4D2B" }}
        >
          {title}
        </Typography>

        {/* Description */}
        <Typography
          variant="body1"
          color="text.secondary"
          mt={1}
          sx={{ lineHeight: 1.7 }}
        >
          {description}
        </Typography>

        {/* Price Grid */}
        <Grid container spacing={2} mt={4}>
          {prices.map((p) => (
            <Grid item xs={6} key={`${title}-${p.label}`}>
              <Box
                sx={{
                  background: "#F4F6F1",
                  p: 2.5,
                  borderRadius: 3,
                  textAlign: "center",
                  transition: "0.3s",
                  border: "1px solid transparent",
                  "&:hover": {
                    borderColor: "#1F4D2B",
                    background: "#ffffff",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.08)"
                  }
                }}
              >
                <Typography
                  variant="body2"
                  sx={{ color: "#666" }}
                >
                  {p.label}
                </Typography>

                <Typography
                  variant="h6"
                  fontWeight={700}
                  sx={{ color: "#1F4D2B", mt: 0.5 }}
                >
                  {p.price}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* CTA */}
      <Button
        fullWidth
        variant="contained"
        onClick={onEnquiry}
        sx={{
          mt: 5,
          py: 1.6,
          borderRadius: 50,
          fontWeight: 700,
          fontSize: "1rem",
          background: "linear-gradient(90deg, #1F4D2B, #2E6B3E)",
          boxShadow: "0 6px 18px rgba(31,77,43,0.3)",
          textTransform: "none",
          "&:hover": {
            background: "linear-gradient(90deg, #173A21, #255A33)",
            boxShadow: "0 10px 24px rgba(31,77,43,0.4)"
          }
        }}
      >
        Enquiry Now
      </Button>
    </Card>
  );
}
